/* unplugin-vue-components disabled */import script from "./WOSkills.vue?vue&type=script&setup=true&lang=js"
export * from "./WOSkills.vue?vue&type=script&setup=true&lang=js"

import "./WOSkills.vue?vue&type=style&index=0&id=0ac6c3ac&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac6c3ac"]])

export default __exports__